<section id="page-section" class="page-content-container">
    <div class="container-fluid first-container">
      <div class="news-content-container2">
        <div [innerHTML]="safeContent"></div>
      </div>
    </div>
  </section>
  